document.addEventListener('DOMContentLoaded', function() {
  const icon = document.querySelector('img[src*="icon2.png"]');
  const textBlock = document.querySelector('.text-block--AcHlzZHRDQXR1d2FTa__text_gXMUag');
  
  if (icon && textBlock) {
    // Supprimer l'effet néon rose par défaut
    textBlock.style.boxShadow = 'none';
    
    icon.addEventListener('click', function() {
      textBlock.classList.toggle('neon-active');
    });
  }
});
